'use client';
import { makeStyles, tokens } from '@fluentui/react-components';
export const useAttachmentHeaderStyles = makeStyles({
    root: {
        display: 'block',
        fontSize: tokens.fontSizeBase300,
        fontWeight: tokens.fontWeightSemibold,
        lineHeight: 1.4286
    }
});
